import { FunctionComponent } from "react";
import { selectActiveSite } from "../../selectors/sites.js";
import { useAppSelector } from "../../store/hooks.js";
import moduleBaseStyles from "../../stylesheets/components/module-base.module.css";
import styles from "../../stylesheets/components/portal-module.module.css";
import { BaseModuleProps, PortalModuleSettings } from "../../types/index.js";
import {
  getActiveColorScheme,
  getSupportedLanguage,
} from "../../utils/utils.js";
import ModuleHeadings from "../ModuleHeadings.js";
import ModuleWithHeadings from "../ModuleWithHeadings.js";
import PortalWidget from "../PortalWidget.js";

interface Props extends BaseModuleProps<PortalModuleSettings> {}

const PortalModule: FunctionComponent<Props> = ({
  translatedModule: {
    id,
    settings: { textAlign, showSearch, id: settingsId },
    translation: {
      languageId,
      settings: { title, subtitle },
    },
  },
  translatedModule,
  isFirstOnPage,
}) => {
  const site = useAppSelector(selectActiveSite);
  const scheme = useAppSelector((state) =>
    getActiveColorScheme(state.colorSchemes, site, translatedModule),
  );
  const settings = {
    id: settingsId,
    lang: getSupportedLanguage(languageId, ["de", "it", "en"]),
    colorScheme: scheme,
    showSearch,
  };

  return (
    <ModuleWithHeadings
      title={title}
      subtitle={subtitle}
      id={id}
      className={styles.PortalModule}
      colors={{ background: scheme.main.background }}
    >
      <div className={moduleBaseStyles.Module__Wrapper}>
        <ModuleHeadings
          scheme={scheme}
          isFirstOnPage={isFirstOnPage}
          textAlign={textAlign}
          title={title}
          subtitle={subtitle}
        />
      </div>
      <PortalWidget settings={settings} />
    </ModuleWithHeadings>
  );
};

export default PortalModule;
